var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { config } from "core/utils/config";
import { Env } from "core/utils/env";
import { getVariant, pageToRegularPageInfo, pushPageView, pushProductClick, pushProductImpression, pushSearchResultsView, pushVtmGoClick, } from "./tracking";
export function trackProductClick(list, products) {
    pushProductClick({ actionField: { list: list, action: "click" }, products: products });
}
export function trackRoutingClick(list, products) {
    pushVtmGoClick({ actionField: { list: list, action: "click" }, products: products });
}
export function trackSearchInfo(type, term, resultsCount, filters) {
    pushSearchResultsView({
        // eslint-disable-next-line camelcase
        search_term: term,
        // eslint-disable-next-line camelcase
        search_results: resultsCount,
    }, type, filters);
}
export function trackPage(page) {
    if (Env.isServer)
        return;
    pushPageView(pageToRegularPageInfo(page));
}
export function trackStaticPage(pageInfo) {
    if (Env.isServer)
        return;
    pushPageView({
        page: __assign(__assign({}, pageInfo), { brand: config.brand, language: config.language }),
    });
}
export function trackPageError(pageError) {
    if (Env.isServer)
        return;
    switch (pageError.kind) {
        case "InternalServerError":
            pushPageView({
                page: {
                    type: "Error",
                    message: "Something went wrong. (InternalServerError) ".concat(pageError.message),
                },
            });
            break;
        case "NotFoundError":
            pushPageView({
                page: {
                    type: "Error",
                    message: "Page not found. (NotFoundError) ".concat(pageError.message),
                },
            });
    }
}
export function trackContentBanner(typename, item) {
    var impression = {
        list: typename,
        id: item.id,
        name: item.name,
        category: item.category,
        variant: item.variant,
    };
    trackProductImpression([impression]);
}
export function trackCollection(typename, items) {
    var impressions = items.map(function (item, index) { return ({
        list: typename,
        id: item.uuid,
        name: item.title,
        category: item.type,
        position: index + 1,
        variant: getVariant(item),
    }); });
    trackProductImpression(impressions);
}
export function trackProductImpression(impressions) {
    pushProductImpression(impressions);
}
